angular.module('impactx.approval').directive('ixApprovalUser', function () {
        return {
            scope: {
                status: '=',
                statusMessage: '=',
                readOnly: '=',
                user: '=',
                externalStep: '=',
                deleteFn: '&',
                isFirstEntry: "=",
                isLastEntry: "=",
                onlyOneEntry: "=",
                canRedirect: '=?',
                redirectLabel: '@?',
                redirectFunction: '&?',
                canRedirectAny: '=?',
                representedByLabel: "@"
            },
            restrict: 'E',
            templateUrl: 'shared/approval/templates/approval-user.tmpl.html',
            controller: 'ApprovalUserCtrl',
            controllerAs: 'approvalUserCtrl'
        }
    }
);